import React, { useState, useRef, useEffect } from "react";
import { MapPin } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

// Autocomplétion commune française (API officielle geo.api.gouv.fr via le backend).
// onSelect reçoit { city, postal_code, department, region } lorsqu'une commune est choisie,
// ou { city } pendant la frappe libre.
export function CityAutocomplete({ value, onSelect, placeholder = "Ville", className = "", dark = true, testId = "city-input" }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const tRef = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  const search = (val) => {
    setQ(val);
    onSelect && onSelect({ city: val });
    if (tRef.current) clearTimeout(tRef.current);
    if ((val || "").trim().length < 2) { setResults([]); setOpen(false); return; }
    tRef.current = setTimeout(async () => {
      try {
        const r = await fetch(`${API}/api/geo/communes?q=${encodeURIComponent(val.trim())}`);
        const d = await r.json();
        setResults(d.results || []);
        setOpen((d.results || []).length > 0);
      } catch (_) { /* silencieux */ }
    }, 250);
  };

  const pick = (c) => {
    setQ(c.city);
    setOpen(false);
    setResults([]);
    onSelect && onSelect({ city: c.city, postal_code: c.postal_code, department: c.department, region: c.region });
  };

  return (
    <div className="relative">
      <input
        value={q}
        onChange={(e) => search(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className={className}
        data-testid={testId}
        autoComplete="off"
      />
      {open && results.length > 0 && (
        <div
          className={`absolute z-[60] left-0 right-0 mt-1 max-h-60 overflow-auto rounded-md border shadow-2xl ${dark ? "bg-[#0d0d10] border-white/15" : "bg-white border-zinc-200"}`}
          data-testid="city-suggestions"
        >
          {results.map((c, i) => (
            <button
              key={`${c.city}-${c.postal_code}-${i}`}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); pick(c); }}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors ${dark ? "text-zinc-200 hover:bg-[#C19A6B]/20" : "text-zinc-800 hover:bg-[#C19A6B]/10"}`}
              data-testid={`city-suggestion-${i}`}
            >
              <MapPin className="w-3.5 h-3.5 text-[#C19A6B] shrink-0" />
              <span className="font-medium">{c.city}</span>
              <span className={dark ? "text-zinc-500" : "text-zinc-500"}>· {c.postal_code} · {c.department}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CityAutocomplete;
